module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-plus-287c119c.svg";